module.exports = __webpack_public_path__ + "953ce7f2d303322f4635d7638335726d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Sintony-Regular.ttf
// module id = 726
// module chunks = 0